export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10527.614eb07d.jpg";